import React, { memo } from "react";
import TextField from "@mui/material/TextField";

const MemoizedTextField = memo(function TextFieldComponent(props) {
  return (
    <TextField
      {...props}
      sx={{
        "& .MuiOutlinedInput-root": {
          "&.Mui-focused fieldset": {
            borderColor: "#5652B0",
          },
        },
        "& .MuiInputLabel-root.Mui-focused": {
          color: "#5652B0",
        },
        ...props.sx,
      }}
    />
  );
});

export default MemoizedTextField;
